"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Minus = function (props) { return (react_1.default.createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 2.2", role: "img", "aria-labelledby": "minus_title_" + props.id + " minus_desc_" + props.id }, props),
    react_1.default.createElement("title", { id: "minus_title_" + props.id }, "Minus"),
    react_1.default.createElement("desc", { id: "minus_desc_" + props.id }, "A rounded rectangle forming a minus sign"),
    react_1.default.createElement("path", { className: "fill", d: "M12.9.4c.3 0 .6.2.6.5V1c0 .3-.3.6-.6.6H1.1c-.3 0-.6-.2-.6-.5V1c0-.3.3-.6.6-.6h11.8z", fill: "#0479cd" }))); };
exports.Minus = Minus;
//# sourceMappingURL=Minus.js.map